// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-card-card-kXsh_ {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 74px;
  text-align: left;
  background-color: var(--color-white);
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-xl);
  padding: 12px;
}

.onboarding-card-iconContainer-f_s82,
.onboarding-card-number-j8DcW {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  color: var(--onboarding-accent-color, var(--color-blue-500));
  background-color: var(--onboarding-accent-soft, var(--color-blue-50));
  border-radius: 50%;
}

.onboarding-card-icon-afrdR {
  --size: 23px;
}

.onboarding-card-number-j8DcW {
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
}

.onboarding-card-title-hvJ7c {
  color: var(--color-neutral-900);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.35;
  margin: 0px;
}

.onboarding-card-description-zowj1 {
  color: var(--color-neutral-600);
  font-size: var(--text-xs);
  line-height: 1.4;
  margin: 5px 0px 0px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/onboarding-card/onboarding-card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 74px;\n  text-align: left;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-xl);\n  padding: 12px;\n}\n\n.iconContainer,\n.number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  color: var(--onboarding-accent-color, var(--color-blue-500));\n  background-color: var(--onboarding-accent-soft, var(--color-blue-50));\n  border-radius: 50%;\n}\n\n.icon {\n  --size: 23px;\n}\n\n.number {\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n}\n\n.title {\n  color: var(--color-neutral-900);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.35;\n  margin: 0px;\n}\n\n.description {\n  color: var(--color-neutral-600);\n  font-size: var(--text-xs);\n  line-height: 1.4;\n  margin: 5px 0px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `onboarding-card-card-kXsh_`,
	"iconContainer": `onboarding-card-iconContainer-f_s82`,
	"number": `onboarding-card-number-j8DcW`,
	"icon": `onboarding-card-icon-afrdR`,
	"title": `onboarding-card-title-hvJ7c`,
	"description": `onboarding-card-description-zowj1`
};
export default ___CSS_LOADER_EXPORT___;
